import type { RootState } from "../store";

// state.featureStatus is never undefined in practice, but may be undefined
// in the jest testing environment
export const selectGAFeatures = (state: RootState) => state.featureStatus?.ga;
